module.exports = __webpack_public_path__ + "static/img/o5.445377e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/owl/o5.jpg
// module id = cBR2
// module chunks = 0